import { useState, useEffect, useCallback, useRef } from 'react';
import { notifyDone } from '../utils/notifications';
import { s } from '../constants/styles';

export default function RestTimer({ endTime, totalSeconds, onDismiss }) {
  const calcLeft = useCallback(() => Math.ceil((endTime - Date.now()) / 1000), [endTime]);
  const [left, setLeft] = useState(calcLeft);
  const fired = useRef(false);

  useEffect(() => {
    fired.current = false;
    setLeft(calcLeft());
    const id = setInterval(() => {
      const l = calcLeft();
      setLeft(l);
      if (l <= 0 && !fired.current) { fired.current = true; notifyDone(); clearInterval(id); }
    }, 500);
    return () => clearInterval(id);
  }, [endTime, calcLeft]);

  const pct = Math.max(0, left) / totalSeconds;
  const r = 36, c = 2 * Math.PI * r;
  const mins = Math.floor(Math.max(0, left) / 60);
  const secs = Math.max(0, left) % 60;
  const done = left <= 0;

  return (
    <div style={{
      flexShrink: 0, display: "flex", alignItems: "center", gap: 14, padding: "12px 16px",
      background: done ? "rgba(52,211,153,0.06)" : "rgba(79,143,255,0.05)",
      borderTop: `1px solid ${done ? "rgba(52,211,153,0.2)" : "rgba(79,143,255,0.1)"}`,
      borderBottom: "1px solid rgba(255,255,255,0.03)",
    }}>
      <div style={{ position: "relative", width: 48, height: 48, flexShrink: 0 }}>
        <svg width="48" height="48" viewBox="0 0 100 100" style={{ transform: "rotate(-90deg)" }}>
          <circle cx="50" cy="50" r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="8" />
          <circle cx="50" cy="50" r={r} fill="none"
            stroke={done ? "#34d399" : left <= 10 ? "#fbbf24" : "#4f8fff"}
            strokeWidth="8" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
            style={{ transition: "stroke-dashoffset 0.5s linear" }} />
        </svg>
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: done ? 11 : 10, fontWeight: 800, color: done ? "#34d399" : "var(--text-1)", fontVariantNumeric: "tabular-nums" }}>
            {done ? "GO" : `${mins}:${String(secs).padStart(2, "0")}`}
          </span>
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: done ? "var(--green)" : "var(--text-1)" }}>
          {done ? "Rest complete — go!" : "Resting..."}
        </div>
        <div style={{ fontSize: 11, color: "var(--text-3)" }}>{totalSeconds}s timer</div>
      </div>
      <button onClick={onDismiss} style={{ ...s.btnG, padding: "10px 16px", fontSize: 13, fontWeight: 700 }}>
        {done ? "Done" : "Skip"}
      </button>
    </div>
  );
}
